import { useCallback } from "react";

import { API_BASE_URL } from "@/api/api.config";
import useRestMutation from "@/remoteState/useRestMutation";

const useStudentClassroomPost = () => {
  const setStudentClassroom = useCallback((payload) => {
    return new Request(`${API_BASE_URL}/api/v2/student-classroom/`, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" },
    });
  }, []);

  return useRestMutation(setStudentClassroom);
};

export default useStudentClassroomPost;
